import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

interface ServiceFAQProps {
  faqs: FAQItem[];
  theme?: 'dark' | 'light';
}

const ServiceFAQ = ({ faqs, theme = 'dark' }: ServiceFAQProps) => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="py-24 bg-pg">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        {/* Header */}
        <div className="text-center mb-14 scroll-reveal">
          <span className="inline-block text-[#00D9FF] text-[11px] font-semibold uppercase tracking-[3px] mb-4">
            Common Questions
          </span>
          <h2 className="text-3xl lg:text-4xl font-black text-[var(--tp)] mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-base max-w-xl mx-auto text-[var(--tm)]">
            Answers to the questions we hear most often. Don&apos;t see yours?{' '}
            <a href="tel:+12693700765" className="text-[#00D9FF] hover:underline cursor-pointer">Give us a call.</a>
          </p>
        </div>

        {/* Accordion */}
        <div className="flex flex-col gap-3">
          {faqs.map((faq, i) => {
            const isOpen = openIndex === i;
            return (
              <div
                key={i}
                className={`scroll-reveal scroll-delay-${Math.min(i + 1, 6)} rounded-xl border overflow-hidden transition-all duration-300 border-[var(--bd)] ${
                  isOpen ? 'bg-cr border-[#00D9FF]/20' : 'bg-cr hover:border-[#00D9FF]/20'
                }`}
              >
                <button
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer"
                  onClick={() => setOpenIndex(isOpen ? null : i)}
                >
                  <span className="text-[15px] font-semibold leading-snug text-[var(--tp)]">
                    {faq.question}
                  </span>
                  <span className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-all duration-300 ${
                    isOpen ? 'bg-[#00D9FF] text-[#0A1628] rotate-45' : 'bg-[#00D9FF]/10 text-[var(--tm)]'
                  }`}>
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-add-line text-base" />
                    </span>
                  </span>
                </button>
                <div className={`overflow-hidden transition-all duration-350 ${isOpen ? 'max-h-60' : 'max-h-0'}`}>
                  <div className="px-6 pb-6 text-[14px] leading-relaxed text-[var(--tm)]">
                    {faq.answer}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServiceFAQ;
